<template>
  <div class="establishModalWrap">
    <div class="mask" @click="closeModal"></div>
    <div class="establishBox" v-loading="importLoading" >
      <div class="title">订单预处理
        <!-- <span class="example">模板下载：<a class="link" :href="exampleLink">云仓货品上传-标准格式模板.xlsx</a></span> -->
      </div>
      <div class="uploadContent">
        <!-- <div class="oneLine">商家名称： <span class="darkBlue">{{infoObj.user_organization_name||infoObj.user_individual_name}}</span>
        </div>
        <div class="oneLine" v-if="infoObj.user_cellphone">商家手机号：<span class="darkBlue">{{infoObj.user_cellphone}}</span></div>
        <div class="oneLine">商家ID: <span class="blue"></span>{{infoObj.user_id}}</div> -->
        <div class="imgPrevArea">
          <div class="oneFileBLock" v-for="(list,index) in fileData">
            <span style="margin-right: 20px;">{{list.name}}</span>
            <el-tag type="danger" size="mini" @click="deleteFile(index)" class="deleteIcon">删除</el-tag>
          </div>
        </div>
        <el-upload :show-file-list="false" ref="upload" list-type="text" accept=".xlsx,.xls" action="" :on-change="changeHandler"
          :limit="1" :auto-upload="false">
          <el-button slot="trigger" type="primary" v-show="fileData.length<1">点击选取文件</el-button>
          <el-button type="danger" v-show="fileData.length>=1" @click="submitUpload">确定上传该文件</el-button>
        </el-upload>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    ajaxPost,
    api,
    ajaxLogin
  } from "@/common/request.js";
  import {
    json,
    wordData,
    utils
  } from "@/common/common.js";
  import {
    ajaxImport
  } from '@/common/request_import.js'
  import {
    getSignStr
  } from '@/common/tool.js'
  import { saveAs } from 'file-saver'
  import moment from 'moment'

  export default {
    name: 'hexiao',
    computed: {
      infoObj() {
        return {}
      },
      adminId() {
        return utils.getAdminId()
      },
      token() {
        return utils.getToken()
      }
    },
    data() {
      return {
        fileData: [],
        importLoading:false,
        exampleLink: api.imgPrev + 'static/digital_warehouse/%E4%BA%91%E4%BB%93%E8%B4%A7%E5%93%81%E4%B8%8A%E4%BC%A0-%E6%A0%87%E5%87%86%E6%A0%BC%E5%BC%8F%E6%A8%A1%E6%9D%BF.xlsx'
      }
    },
    methods: {
      closeModal() {
        // this.$emit("close")
        // this.memo = ''
        // this.result = ''
        // this.fileData=[]
        this.fileData.splice(0)
      },
      closeModalAndSuccess() {
        // this.$emit("success")
        // this.memo = ''
        // this.result = ''
        // this.fileData=[]
        this.fileData.splice(0)
      },
      changeHandler(file, fileList) {
        console.log(file, fileList);
        this.fileData = fileList
      },
      deleteFile(index) {
        this.$confirm('确认删除文件重新选取吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fileData.splice(index)
        }).catch(() => {});

      },
      // 批量上传
      submitUpload() {
        // console.log(this.fileData)
        let _this = this
        if (!this.fileData || this.fileData.length == 0) {
          alert("没有选取文件")
          return false
        }
        var fileObj = this.fileData[0]
        // console.log(fileObj)
        if (typeof(fileObj) == "undefined" || fileObj.size <= 0) {
          return;
        }
        let number = 25
        let sizeNumber = number * 1024 * 1024
        if (fileObj.size > sizeNumber) {
          _this.$message({
            message: "文件大小不能超过" + number + "M", //接口返回一个页面
            type: 'warning',
            duration: 1500
          });
          return;
        }
        // 图片预览
        // var fileReader = new FileReader();
        // fileReader.readAsDataURL(fileObj);
        // fileReader.onload = function () {
        //   $("#imgPrev").attr('src', this.result);
        // };

        var formFile = new FormData();

        var signArg = {}
        var signStr = getSignStr(signArg)
        formFile.append("upload_file", fileObj.raw); //加入文件对象
        formFile.append("sign", signStr); //加入文件对象
        var arg = formFile;
        // console.log("转换之后的参数1", formFile)
        var url = '/digital_warehouse_php/?s=order&op=pre'
        _this.importLoading = true
        ajaxImport(url, arg).then(function(res) {
          console.log(res)
          _this.importLoading = false
          if (res.error_code == '0') {
            _this.$message({
              message: "预处理完成", //接口返回一个页面
              type: 'success',
              duration: 1500
            });
            _this.closeModalAndSuccess()
            var resultUrl=res.data.file
            saveAs(resultUrl, `数字云仓订单预处理完成_${moment().format("YYYY年MM月DD日HH时mm分")}`);
            // window.location.href=res.data.file


          } else {
            let msg=res.error_msg
            _this.$message({
              message: msg || "上传文件报错", //接口返回一个页面
              type: 'error',
              duration: 4000
            });
          }
        }).catch(function(res) {
          _this.importLoading = false
        })


      }
    },
    mounted() {

    }
  }
</script>

<style scoped lang="scss">
  .establishModalWrap {
    padding:20px;
    // position: fixed;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // z-index: 100;

    .mask {
      // background: rgba(0, 0, 0, 0.5);
      // position: fixed;
      // top: 0;
      // left: 0;
      // right: 0;
      // bottom: 0;
    }

    .establishBox {
      // position: fixed;
      // z-index: 1000;
      // left: 33%;
      // top: 20%;
      width: 30%;
      min-width: 300px;
      border: 1px solid #eee;
      border-radius: 4px;
      background: #ddd;
      border-radius: 2px;

      input {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 8px;
      }

      .title {
        font-size: 18px;
        padding: 19px 25px;
        border-bottom: 1px solid #eee;
        position: relative;
        .example {
          position: absolute;
          right: 16px;
          bottom: 20px;
          font-size: 12px;
        }
      }

      .oneArea {
        margin: 20px 0;
      }

      .oneline {
        margin: 10px 0;
        padding: 0 25px;
      }

      .mylabel {
        position: relative;
        display: inline-block;
        min-width: 60px;
        text-align-last: justify;
        margin-right: 20px;
        font-weight: bold;

        .redStar {
          position: absolute;
          left: -10px;
          top: 0;
        }
      }

      .text {}

      .footer {
        text-align: right;
        border-top: 1px solid #eee;
        padding: 14px 25px;

        .btn {
          padding: 5px 16px;
          background: #fff;
          font-size: 12px;
          border-radius: 4px;
        }

        .closeBtn {
          margin-right: 10px;
          border: 1px solid #D9D9D9;
        }

        .submitBtn {
          background: #F81D22;
          color: #fff;
          border: 0;
        }
      }
    }
  }
  .uploadContent{
    padding:20px;
    .oneLine{padding:5px 5px; }
    .imgPrevArea{
      margin-top:30px;
      .oneFileBLock{
         position: relative;color:red;margin-bottom: 20px;
      }
      .deleteIcon:hover{cursor: pointer;color:#ff4b4b;border-color: #f9bcbc;}
    }

    .oneFileBLock{}
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/orderPrev.vue